import { Instance, types } from 'mobx-state-tree';
import Common from '@store/common';
import GenericSpei from '@store/genericSpei';

const FintocStore = types.compose(Common, types.model({}), GenericSpei);

export type IFintocStore = Instance<typeof FintocStore>;
export default FintocStore;
